// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file catpocs/v1/ecr_admin.proto (package catpocs.v1, syntax proto3)
/* eslint-disable */

import { ECRAdminService } from "./ecr_admin_pb";

/**
 * GetRegistryOverview returns high-level statistics about the ECR registry
 *
 * @generated from rpc catpocs.v1.ECRAdminService.GetRegistryOverview
 */
export const getRegistryOverview = ECRAdminService.method.getRegistryOverview;

/**
 * ListRepositories lists all ECR repositories with metrics
 *
 * @generated from rpc catpocs.v1.ECRAdminService.ListRepositories
 */
export const listRepositories = ECRAdminService.method.listRepositories;

/**
 * GetRepositoryDetails returns detailed information about a specific repository
 *
 * @generated from rpc catpocs.v1.ECRAdminService.GetRepositoryDetails
 */
export const getRepositoryDetails = ECRAdminService.method.getRepositoryDetails;

/**
 * GetVulnerableImages returns all images with security vulnerabilities
 *
 * @generated from rpc catpocs.v1.ECRAdminService.GetVulnerableImages
 */
export const getVulnerableImages = ECRAdminService.method.getVulnerableImages;

/**
 * GetUnusedImages returns images that are not currently deployed
 *
 * @generated from rpc catpocs.v1.ECRAdminService.GetUnusedImages
 */
export const getUnusedImages = ECRAdminService.method.getUnusedImages;

/**
 * CleanupUnusedImages identifies and optionally deletes unused images
 *
 * @generated from rpc catpocs.v1.ECRAdminService.CleanupUnusedImages
 */
export const cleanupUnusedImages = ECRAdminService.method.cleanupUnusedImages;
